import React, { useEffect, useState } from 'react'
import left from '../../../Assets/Images/left.svg'
import right from '../../../Assets/Images/right-indicator.svg'

export default function Likert({ left_labels, right_labels, responses }) {
  const [leftPercentage, setLeftPercentage] = useState(0);
  const [rightPercentage, setRightPercentage] = useState(0);


  useEffect(() => {
    let l_percent = 0, r_percent = 0;
    left_labels?.forEach((label) => {
      l_percent += (responses.data[label.label] / responses.total * 100);
    });
    l_percent = Number(l_percent.toFixed(2))
    r_percent = 100 - l_percent;
    setLeftPercentage(l_percent);
    setRightPercentage(r_percent);
  }, [responses, left_labels])

  const displayLabelMap = {
    Performative: "Performance",
    Collaborative: "Collaborative",
    Visionary: "Visionary",
    Strategic: "Strategic",
  };


  const convertFromPercentageToPxScale = ( percentage ) => {
    const totalWidthInPx = 175;
    return (percentage / 100) * totalWidthInPx;
  }

  return (
    <div className='likert-scale'>
      <div className="left">
        {/* <div className='left-stats'>
          <div className={`percentage ${leftPercentage > 50 ? 'higher-percentage' : ''}`}>{leftPercentage}%</div>
          {leftPercentage > 50 && <div className='left-arrow'>
            <img src={right} alt="" />
          </div>}
        </div> */}
        {left_labels?.map((label, i) => (
          <div
            key={i}
            className='left-scale-section'
            style={{
              // width: `${Math.round(responses.data[label.label]) > 5 ? Math.round(responses.data[label.label]) - 5 : Math.round(responses.data[label.label])}%`,
              width: `${convertFromPercentageToPxScale(responses.data[label.label])}px`,
              backgroundColor: label.color,
              borderTopLeftRadius: '5.17px',
              borderBottomLeftRadius: '5.17px',
              height:"22px"
            }}
          />
        ))}
      </div>
      <div className="center-border"></div>
      <div className="right">
        {right_labels?.map((label, i) => (
          <div
            key={i}
            className='right-scale-section'
            style={{
              // width: `${Math.round(responses.data[label.label]) > 5 ? Math.round(responses.data[label.label]) - 5 : Math.round(responses.data[label.label])}%`,
              width: `${convertFromPercentageToPxScale(responses.data[label.label])}px`,
              backgroundColor: label.color,
              borderTopRightRadius: '5.17px',
              borderBottomRightRadius: '5.17px',
              height:"22px"
            }}
          />
        ))}
        {/* <div className='right-stats'>
          {rightPercentage > 50 && <div className='right-arrow'>
            <img src={left} alt="" />
          </div>}
          <div className={`percentage ${rightPercentage > 50 ? 'higher-percentage' : ''}`}>{rightPercentage}%</div>
        </div> */}
      </div>
      <div className="indicator-line left-indicator-80"></div>
      <div className="indicator-line left-indicator-60"></div>
      <div className="indicator-line left-indicator-40"></div>
      <div className="indicator-line left-indicator-20"></div>
      <div className="indicator-line right-indicator-20"></div>
      <div className="indicator-line right-indicator-40"></div>
      <div className="indicator-line right-indicator-60"></div>
      <div className="indicator-line right-indicator-80"></div>
      <div className="indicator-line mid-left-indicator"></div>
      <div className="indicator-line mid-right-indicator"></div>


      <div className="likert-label left-label">{left_labels?.[0]?.label}</div>
      <div className="likert-label right-label">{displayLabelMap[right_labels?.[0]?.label] || right_labels?.[0]?.label}</div>
    </div>
  )
}
